export enum BASE_LOADER_DIRECTION {
  ROW = 'row',
  COLUMN = 'column',
}
